import React from 'react';
import {openExternalLink, openExternalLinkSimple} from 'utils/openExternalLink';
import { compose, mapProps } from 'recompose';
import { signOut } from 'modules/authentication/helpers/nextauth';

const enhance = compose(
  mapProps(({ ...other }) => {
    return {
      logout: () => {
        signOut(window.location.href)
      },
      ...other,
    };
  })
);


interface ExternalLinkProps {
  url: string;
  children: any;
  className?: string;
  openInNewTab?: boolean;
  elementType?: string;
  onClick?: (e: any) => void;
  logout: () => Promise<any>;
  noAuth?: boolean;
}

class ExternalLink extends React.Component<ExternalLinkProps> {

  static defaultProps = {
    elementType: 'div',
  };

  onLinkClick = (e) => {
    e.preventDefault();
    if (this.props.onClick) {
      this.props.onClick(e);
    }
    if (this.props.noAuth) {
      return openExternalLinkSimple(this.props.url, this.props.openInNewTab);
    }
    return openExternalLink(this.props.url, this.props.openInNewTab);
  };

  render() {
    if (this.props.elementType === 'div') {
      return (
        <div onClick={this.onLinkClick} className={this.props.className}>
          {this.props.children}
        </div>
      );
    }
    if (this.props.elementType === 'span') {
      return (
        <span onClick={this.onLinkClick} className={this.props.className}>
          {this.props.children}
        </span>
      );
    }
    if (this.props.elementType === 'a') {
      return (
        <a onClick={this.onLinkClick} className={this.props.className} href={this.props.url}>
          {this.props.children}
        </a>
      );
    }
    return null;
  }
}

export default enhance(ExternalLink) as any
